export default __webpack_public_path__ + "static/media/burger-tomato.12512c08.svg";